<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="p-relative">
    <h3 class="mb-2 text-center">Reject Purple Phone Contact?</h3>

    <p class="mb-1">
      If rejected <b>{{contact.user.firstname }} {{ contact.user.lastname }}</b> will not be able to make calls to prisoner <b>{{contact.prisoner_number}}</b> via purple phone. Are you sure?
    </p>

    <section>
      <section>
        <label class="d-flex">Rejection reason
          <small class="ml-auto">{{ rejectionReasonMaxLength - reason.length }} characters remaining</small>
        </label>
        <b-form-textarea v-model="reason" :maxlength="rejectionReasonMaxLength"
                         placeholder="Enter reason for rejecting"></b-form-textarea>
      </section>
    </section>

    <section class="d-inline-flex full-width mt-2" :class="{'disabled': loading}">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="close()">Close</b-button>
      <b-button variant="danger" @click="reject()" :class="{'disabled': !isValid()}">Reject</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
import ContactService from '@/services/ContactService';

export default {
  components: {},
  props: {
    contact: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      rejectionReasonMaxLength: 150,
      reason: '',
    };
  },
  methods: {
    isValid() {
      return this.reason.length > 0
    },
    async reject() {
      this.loading = true;
      try {
        const { data } = await ContactService.purplePhoneReject(this.contact._id, {
          rejection_reason: this.reason,
        });
        this.$toast.success('The contact has been rejected for purple phone calls', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.$emit('rejected', data)
        this.close();
      } catch(err) {
        console.error('Error rejecting contact: ', err);
        this.$toast.error('Something went wrong rejecting the contact, please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close', true); // emit a close
    }
  },
};
</script>
